import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useSupplierInvoices, SupplierInvoice } from './useData';
import { moduleConfig, getColumns, getTableActions, getToolbarIcon } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<SupplierInvoice>
      useData={useSupplierInvoices}
      config={{
        ...moduleConfig,
        getColumns,
        getTableActions,
        getToolbarIcon,
      }}
    />
  );
};

export default List;
